export const KIM_MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const KIM_MAX_NUMBER_OF_FILES = 3;

// Single-document formats Kim can ingest directly.
export const KIM_ALLOWED_FILE_TYPES = ['.pdf', '.doc', '.docx'];

// MIME-typed accept map for react-dropzone's `accept` option.
export const KIM_DROPZONE_ACCEPT: Record<string, string[]> = {
  'application/pdf': ['.pdf'],
  'application/msword': ['.doc'],
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
};

// Comma-separated extension list for the native <input type="file" accept="..."> attribute.
export const KIM_FILE_INPUT_ACCEPT = KIM_ALLOWED_FILE_TYPES.join(',');
